import {Pipe, PipeTransform} from '@angular/core';
import {ellipsisLongText} from '../../utils';

@Pipe({name: 'ellipsisLongText'})
export class EllipsisLongText implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    return ellipsisLongText(value, args[0]);
  }
}
